import React, { useState } from "react";
import { getApiUrl } from "../utils/apiConfig";
import userStore from "../utils/UserStore";

const LoginPage = ({ setIsLoggedIn }) => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [errors, setErrors] = useState({
        email: "",
        password: "",
        server: "",
    });
    const [isLoading, setIsLoading] = useState(false);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: "",
            server: "",
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let newErrors = {};
        let isValid = true;

        // Validate email
        if (!formData.email) {
            newErrors.email = "Email is required";
            isValid = false;
        } else if (!validateEmail(formData.email)) {
            newErrors.email = "Please enter a valid email";
            isValid = false;
        }

        // Validate password
        if (!formData.password) {
            newErrors.password = "Password is required";
            isValid = false;
        }

        setErrors(newErrors);

        if (isValid) {
            setIsLoading(true);
            try {
                const response = await fetch(getApiUrl("/auth/login"), {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || "Login failed");
                }

                // Store the token in localStorage
                localStorage.setItem("token", data.token);
                localStorage.setItem("email", formData.email);

                // Store user data in singleton for global access
                if (data.user) {
                    userStore.setUser(data.user);
                }

                setIsLoading(false);
                setIsLoggedIn(true);
                // You could redirect here or update app state
                console.log("Login successful", data);
            } catch (error) {
                setErrors((prev) => ({
                    ...prev,
                    server: error.message,
                }));
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                <h2 className="mt-10 text-center text-2xl font-bold leading-9 text-gray-900">Sign in to your account</h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                {errors.server && <div className="mb-4 p-3 text-sm text-red-500 bg-red-100 rounded-md">{errors.server}</div>}

                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                            Email address
                        </label>
                        <div className="mt-2">
                            <input
                                type="email"
                                name="email"
                                id="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                autoComplete="email"
                                className={`block w-full rounded-md px-3 py-1.5 text-gray-900 
                                    ${errors.email ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-500" : "border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"} shadow-sm placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6`}
                            />
                            {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
                        </div>
                    </div>

                    <div>
                        <div className="flex items-center justify-between">
                            <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                                Password
                            </label>
                            <div className="text-sm">
                                <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">
                                    Forgot password?
                                </a>
                            </div>
                        </div>
                        <div className="mt-2">
                            <input
                                type="password"
                                name="password"
                                id="password"
                                value={formData.password}
                                onChange={handleInputChange}
                                autoComplete="current-password"
                                className={`block w-full rounded-md px-3 py-1.5 text-gray-900 
                                    ${errors.password ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-500" : "border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"} shadow-sm placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6`}
                            />
                            {errors.password && <p className="mt-1 text-sm text-red-500">{errors.password}</p>}
                        </div>
                    </div>

                    <div>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-indigo-400"
                        >
                            {isLoading ? "Signing in..." : "Sign in"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
